import { lazy } from 'react'

export default {
    path: '/report/analisi-commessa',
    title: 'Analisi commessa',
    authenticated: true,
    component: lazy(() => import('./filter'))
}